import React from 'react';
import PropTypes from 'prop-types';

import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPDesktopHeroGallery from '../PDPDesktopHeroGallery';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPDesktopMarxentConfigurator from '../../modular-configurator/PDPMarxentConfigurator';

const PDPDesktopPhotoPanelInner = ({
  isEditOrder = false,
  pdpIsModularBYOProduct = false,
  marxentPostHogFlag = false,
  slug,
  hideMarxent = true,
  unavailableFabric = false,
}) => (
  <div className="sticky top-8">
    {pdpIsModularBYOProduct && marxentPostHogFlag === 'test' ? (
      <PDPDesktopMarxentConfigurator
        pdpIsModularBYOProduct={pdpIsModularBYOProduct}
        slug={slug}
        key={slug}
        hideMarxent={hideMarxent}
        unavailableFabric={unavailableFabric}
      />
    ) : (
      <PDPDesktopHeroGallery
        isEditOrder={isEditOrder}
        pdpIsModularBYOProduct={pdpIsModularBYOProduct}
      />
    )}
    {!isEditOrder && <PDPKeySellingPoints />}
  </div>
);

PDPDesktopPhotoPanelInner.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  marxentPostHogFlag: PropTypes.string,
  slug: PropTypes.string,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool,
};

const PDPDesktopPhotoPanel = props => (
  <SuspenseWithLoader>
    <PDPDesktopPhotoPanelInner {...props} />
  </SuspenseWithLoader>
);

export default PDPDesktopPhotoPanel;
